module.exports = __webpack_public_path__ + "static/media/Trazado 9163@2x.412902f2.png";